import { MoreVert } from '@mui/icons-material';
import {
  TableRow,
  TableCell,
  Typography,
  IconButton
} from '@mui/material';
import { DateTime } from 'luxon';
import { menuUtil } from 'modules/common/layer00';
import { InstallationMenu } from 'modules/components/layer19';

import React from 'react';
import {
  useLocation,
  useNavigate
} from 'react-router-dom';

export type ProjectInstallationRowProps = {
  id: string;
  name: string;
  area: string;
  planId: string;
  numberOfActiveDecisions: number;
  type: string;
  estStartDate: DateTime;
  status: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ProjectInstallationRowProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    anchorEl,
    handleClick,
    handleClose,
    open
  } = menuUtil.useBaseMenuState();

  const handleNavigate = (path: string) => {
    if (path.endsWith('installations')) {
      navigate(`${props.id}`);
    }
    if (path.includes('milestones')) {
      navigate(`../../installations/${props.id}`);
    }
  };

  return (
    <TableRow
      onClick={(e) => {
        e.stopPropagation();
        handleNavigate(location.pathname);
      }}
      content='list'
    >
      <TableCell
        variant='firstRounded'
      >
        <Typography
          variant='body1'
        >
          {props.name}
        </Typography>

      </TableCell>
      <TableCell
        variant='body'
      >
        {props.area}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.type}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.planId}
      </TableCell>
      <TableCell
        variant='body'
      >

        {props.numberOfActiveDecisions}
      </TableCell>
      <TableCell
        variant='body'
      >

        {props.estStartDate.toFormat('LLL, dd, yy')}
      </TableCell>
      <TableCell
        align='right'
        variant='lastRounded'
      >
        <IconButton
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleClick(e);
          }}
        >
          <MoreVert />
        </IconButton>
        {open && (
          <InstallationMenu.FC
            open={open}
            anchorEl={anchorEl ?? null}
            handleClick={handleClick}
            handleClose={handleClose}
            id={props.id}
          />
        )}
      </TableCell>
    </TableRow>
  );

};
